export interface DelayCategory {
	DelayCategoryId: null | number;
	DelayCategoryName: string;
	DelayCategoryColor: string;
	DelayAreaAssetId: null | number;
	IsActive: boolean;
}

export const DELAY_CATEGORY_INITIAL_VALUES: DelayCategory = {
	DelayCategoryId: null,
	DelayAreaAssetId: null,
	DelayCategoryName: "",
	DelayCategoryColor: "",
	IsActive: true,
};
